export default __webpack_public_path__ + "static/media/Group1109.0053676c.svg";